module.exports = __webpack_public_path__ + "static/img/startUp2022.3570dd91.png";